import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { OptimisticCartCountState } from "@thkStore/Store/Widgets/CartCount/OptimisticCartCountState";
import { Draft } from "immer";

const initialState: OptimisticCartCountState = {
    delta: 0,
};

const reducer = {
    // Applied by the add-to-cart handlers the moment the add API succeeds.
    "Cart/OptimisticCount/Add": (
        draft: Draft<OptimisticCartCountState>,
        action: { delta: number },
    ) => {
        draft.delta += action.delta;
    },
    // The authoritative cart finished (re)loading — drop the optimistic delta so the
    // badge shows the real count. Reset on failure too, so a failed reload can't strand it.
    "Data/Carts/CompleteLoadCart": (draft: Draft<OptimisticCartCountState>) => {
        draft.delta = 0;
    },
    "Data/Carts/FailedToLoadCart": (draft: Draft<OptimisticCartCountState>) => {
        draft.delta = 0;
    },
    "Data/Carts/ResetCurrentCartId": (draft: Draft<OptimisticCartCountState>) => {
        draft.delta = 0;
    },
};

const optimisticCartCountReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).optimisticCartCount = optimisticCartCountReducer;

export type ApplicationOptimisticCartCountState = {
    optimisticCartCount: OptimisticCartCountState;
} & ApplicationState;

type Reducers = {
    optimisticCartCount: typeof optimisticCartCountReducer;
};

export type OptimisticCartCountActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
